module.exports = __webpack_public_path__ + "img/img-152.2798c5f8.png";